import { render, staticRenderFns } from "./NetworkError.vue?vue&type=template&id=5920447c&scoped=true"
import script from "./NetworkError.vue?vue&type=script&lang=ts"
export * from "./NetworkError.vue?vue&type=script&lang=ts"
import style0 from "./NetworkError.vue?vue&type=style&index=0&id=5920447c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920447c",
  null
  
)

export default component.exports